import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
import plausible from './plausible';

plausible.enableAutoPageviews();
plausible.enableAutoOutboundTracking();

const router = createBrowserRouter(routes);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
